import { Component, computed, input } from '@angular/core';
import { InnogyComponentRendering } from '@core/jss-models';
import {
  ProductCard,
  ProductCardSectionComponent,
} from '@content/ui/cards/product-cards';
import { getField } from '@core/jss-utils';
import { ImageField, LinkField, TextField } from '@core/jss-proxy';
import {
  computedContentSectionId,
  computedContentSectionTheme,
  ContentSectionComponent,
} from '@core/content-section';
import { RichTextField } from '@sitecore-jss/sitecore-jss-angular';

const TWO_CARD_ROW_SECTION = 2;
const THREE_CARD_ROW_SECTION = 3;

@Component({
  selector: 'wl-product-card-section-container',
  templateUrl: './product-card-section.container.component.html',
  standalone: true,
  imports: [ProductCardSectionComponent, ContentSectionComponent],
})
export class ProductCardSectionContainerComponent {
  readonly rendering = input.required<InnogyComponentRendering>();
  readonly id = computedContentSectionId(this.rendering);
  readonly theme = computedContentSectionTheme(this.rendering);

  readonly numberOfCards = computed<number>(() => {
    switch (this.rendering()?.componentName) {
      case 'ProductCard2Section':
        return TWO_CARD_ROW_SECTION;
      case 'ProductCard3Section':
        return THREE_CARD_ROW_SECTION;
      default:
        return TWO_CARD_ROW_SECTION;
    }
  });

  readonly fields = computed(() => this.rendering().fields);
  readonly title = computed(() => getField<TextField>(this.fields(), 'title'));
  readonly content = computed(() =>
    getField<TextField>(this.fields(), 'content')
  );
  readonly cards = computed(() => {
    const cards = [];
    for (let i = 1; i <= this.numberOfCards(); i++) {
      cards.push(this.getCard(i));
    }
    return cards;
  });

  getCard(index: number) {
    return {
      title: getField<TextField>(this.fields(), `card${index}Title`),
      content: getField<TextField>(this.fields(), `card${index}Content`),
      image: getField<ImageField>(this.fields(), `card${index}Image`),
      button1: getField<LinkField>(this.fields(), `card${index}Button1`),
      button2: getField<LinkField>(this.fields(), `card${index}Button2`),
      cost: getField<TextField>(this.fields(), `card${index}Cost`),
      costAddition: getField<TextField>(
        this.fields(),
        `card${index}CostAddition`
      ),
      details: getField<RichTextField>(this.fields(), `card${index}Details`),
    } as ProductCard;
  }
}
